export class FileCountLimiter {

    constructor(maxCount){
        if(maxCount){
            this.maxCount = maxCount;
        }
    }

    maxCount = 5;//默认设置最大同时并发上传5个

    currentCount = 0;//当前的队列中元素的长度

    list = [];
    allMap = {};

    retry(uid){
        return new Promise((resolve, reject) => {
            if(!uid){
                reject();
            }
            if(this.allMap[uid]){
                this.append(uid, this.allMap[uid]);
                resolve();
            }else{
                reject();
            }
        });
    }

    //追加文件上传方法
    append(uid, fun){
        this.allMap[uid] = fun;
        this.list.push(fun);
        this.currentCount++;
        if(this.currentCount <= this.maxCount){
            this.run();
        }
    }

    /**释放*/
    release = ()=>{
        this.currentCount--;
        this.run();
    };

    /**取出一个方法然后执行*/
    run = ()=>{
        let method = this.list.shift();
        if(method){
            method();
        }
    };

    /**更新队列中的文件状态*/
    updateState = ()=>{
        this.release();
    }

}